import { createContext } from 'react';

const AutocompleteContext = /*#__PURE__*/createContext(null);

export { AutocompleteContext };
